import styled from "styled-components";
import { PlusOutlined } from "../../icons";
import { isFunction, isNonEmptyString } from "../../utils/type-util";
import Flex from "../flex";
import Label from "../label";
import Tag from "../tag";
import FilterDropdown from "./filter-dropdown";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const ExtraContent = styled.div.withConfig({
  displayName: "filter-bar__ExtraContent",
  componentId: "sc-1ce6x1w-0"
})(["float:right;"]);
function FilterBar(_ref) {
  let {
    options,
    descriptors,
    selectedIndex,
    label,
    emptyText,
    allowAdd,
    showSearch,
    onSelect,
    onAdd,
    onRemove,
    extra
  } = _ref;
  const tags = descriptors.map(desc => {
    const selected = desc.dataIndex === selectedIndex;
    const opt = options.find(opt => opt.dataIndex === desc.dataIndex);
    return opt ? /*#__PURE__*/_jsx(Tag, {
      color: getTagColor(desc, opt, selectedIndex),
      onClick: () => onSelect(selected ? null : opt.dataIndex),
      onClose: () => onRemove(opt.dataIndex),
      closable: opt.removable,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [isFunction(opt.icon) ? opt.icon(desc, opt) : opt.icon, opt.formatTag ? opt.formatTag(desc, opt) : opt.label]
      })
    }, opt.dataIndex) : null;
  }).filter(el => el);
  const labelElement = isNonEmptyString(label) ? /*#__PURE__*/_jsx(Label, {
    m: 0,
    children: label
  }) : label;
  const emptyTag = tags.length === 0 && /*#__PURE__*/_jsx(Tag, {
    children: emptyText
  });
  const removableOptions = options.filter(opt => opt.removable);
  const inactiveOptions = options.filter(opt => !descriptors.find(desc => desc.dataIndex === opt.dataIndex));
  const addOperation = allowAdd && inactiveOptions.length > 0 ? /*#__PURE__*/_jsx(FilterDropdown, {
    options: inactiveOptions,
    showSearch: showSearch,
    onClick: e => onAdd(e.key),
    children: /*#__PURE__*/_jsxs(Tag, {
      dashed: true,
      ghost: true,
      children: [/*#__PURE__*/_jsx(PlusOutlined, {}), "Add Filter"]
    })
  }) : /*#__PURE__*/_jsxs(Tag, {
    dashed: true,
    ghost: true,
    disabled: true,
    children: [/*#__PURE__*/_jsx(PlusOutlined, {}), "Add Filter"]
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [extra && /*#__PURE__*/_jsx(ExtraContent, {
      children: extra
    }), /*#__PURE__*/_jsx(Flex, {
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: 2,
        flexWrap: "wrap",
        alignItems: "flex-end",
        children: [labelElement, emptyTag, tags, removableOptions.length > 0 && addOperation]
      })
    })]
  });
}
function getTagColor(descriptor, option, selectedIndex) {
  if (option.validateStatus === "error" || option.validateStatus === "warning") {
    return option.validateStatus;
  }
  if (descriptor.dataIndex === selectedIndex) {
    return "processing";
  }
  return "default";
}
export default FilterBar;